// Avatar options for user profiles
export const avatars = [
  // Animals
  { id: 'cat', emoji: '🐱', name: 'Cat', category: 'animals' },
  { id: 'dog', emoji: '🐶', name: 'Dog', category: 'animals' },
  { id: 'bear', emoji: '🐻', name: 'Bear', category: 'animals' },
  { id: 'panda', emoji: '🐼', name: 'Panda', category: 'animals' },
  { id: 'koala', emoji: '🐨', name: 'Koala', category: 'animals' },
  { id: 'lion', emoji: '🦁', name: 'Lion', category: 'animals' },
  { id: 'tiger', emoji: '🐯', name: 'Tiger', category: 'animals' },
  { id: 'fox', emoji: '🦊', name: 'Fox', category: 'animals' },
  { id: 'rabbit', emoji: '🐰', name: 'Rabbit', category: 'animals' },
  { id: 'monkey', emoji: '🐵', name: 'Monkey', category: 'animals' },
  { id: 'elephant', emoji: '🐘', name: 'Elephant', category: 'animals' },
  { id: 'giraffe', emoji: '🦒', name: 'Giraffe', category: 'animals' },
  
  // Fantasy & Fun
  { id: 'unicorn', emoji: '🦄', name: 'Unicorn', category: 'fantasy' },
  { id: 'dragon', emoji: '🐉', name: 'Dragon', category: 'fantasy' },
  { id: 'alien', emoji: '👽', name: 'Alien', category: 'fantasy' },
  { id: 'robot', emoji: '🤖', name: 'Robot', category: 'fantasy' },
  { id: 'wizard', emoji: '🧙', name: 'Wizard', category: 'fantasy' },
  { id: 'fairy', emoji: '🧚', name: 'Fairy', category: 'fantasy' },
  { id: 'mermaid', emoji: '🧜', name: 'Mermaid', category: 'fantasy' },
  { id: 'vampire', emoji: '🧛', name: 'Vampire', category: 'fantasy' },
  
  // Space & Nature
  { id: 'star', emoji: '⭐', name: 'Star', category: 'nature' },
  { id: 'sun', emoji: '☀️', name: 'Sun', category: 'nature' },
  { id: 'moon', emoji: '🌙', name: 'Moon', category: 'nature' },
  { id: 'rainbow', emoji: '🌈', name: 'Rainbow', category: 'nature' },
  { id: 'flower', emoji: '🌸', name: 'Flower', category: 'nature' },
  { id: 'tree', emoji: '🌳', name: 'Tree', category: 'nature' },
  { id: 'rocket', emoji: '🚀', name: 'Rocket', category: 'space' },
  { id: 'planet', emoji: '🪐', name: 'Planet', category: 'space' },
  
  // Food
  { id: 'pizza', emoji: '🍕', name: 'Pizza', category: 'food' },
  { id: 'burger', emoji: '🍔', name: 'Burger', category: 'food' },
  { id: 'icecream', emoji: '🍦', name: 'Ice Cream', category: 'food' },
  { id: 'cake', emoji: '🎂', name: 'Cake', category: 'food' },
  { id: 'donut', emoji: '🍩', name: 'Donut', category: 'food' },
  { id: 'cookie', emoji: '🍪', name: 'Cookie', category: 'food' },
  
  // Sports & Activities
  { id: 'soccer', emoji: '⚽', name: 'Soccer', category: 'sports' },
  { id: 'basketball', emoji: '🏀', name: 'Basketball', category: 'sports' },
  { id: 'baseball', emoji: '⚾', name: 'Baseball', category: 'sports' },
  { id: 'tennis', emoji: '🎾', name: 'Tennis', category: 'sports' },
  { id: 'music', emoji: '🎵', name: 'Music', category: 'activities' },
  { id: 'art', emoji: '🎨', name: 'Art', category: 'activities' },
  { id: 'book', emoji: '📚', name: 'Book', category: 'activities' },
  { id: 'game', emoji: '🎮', name: 'Game', category: 'activities' },
  
  // Vehicles
  { id: 'car', emoji: '🚗', name: 'Car', category: 'vehicles' },
  { id: 'train', emoji: '🚂', name: 'Train', category: 'vehicles' },
  { id: 'airplane', emoji: '✈️', name: 'Airplane', category: 'vehicles' },
  { id: 'helicopter', emoji: '🚁', name: 'Helicopter', category: 'vehicles' },
  { id: 'boat', emoji: '⛵', name: 'Boat', category: 'vehicles' },
  
  // Objects
  { id: 'crown', emoji: '👑', name: 'Crown', category: 'objects' },
  { id: 'trophy', emoji: '🏆', name: 'Trophy', category: 'objects' },
  { id: 'medal', emoji: '🏅', name: 'Medal', category: 'objects' },
  { id: 'gem', emoji: '💎', name: 'Gem', category: 'objects' },
  { id: 'heart', emoji: '❤️', name: 'Heart', category: 'objects' },
  { id: 'fire', emoji: '🔥', name: 'Fire', category: 'objects' }
];

// Profile color options
export const profileColors = [
  { id: 'blue', color: '#3498db', name: 'Blue' },
  { id: 'red', color: '#e74c3c', name: 'Red' },
  { id: 'green', color: '#2ecc71', name: 'Green' },
  { id: 'purple', color: '#9b59b6', name: 'Purple' },
  { id: 'orange', color: '#f39c12', name: 'Orange' },
  { id: 'pink', color: '#ff69b4', name: 'Pink' },
  { id: 'teal', color: '#1abc9c', name: 'Teal' },
  { id: 'yellow', color: '#f1c40f', name: 'Yellow' },
  { id: 'indigo', color: '#6366f1', name: 'Indigo' },
  { id: 'cyan', color: '#06b6d4', name: 'Cyan' },
  { id: 'lime', color: '#84cc16', name: 'Lime' },
  { id: 'rose', color: '#f43f5e', name: 'Rose' }
];

// Get avatar by ID
export const getAvatarById = (id) => {
  return avatars.find(avatar => avatar.id === id);
};

// Get avatars by category
export const getAvatarsByCategory = (category) => {
  return avatars.filter(avatar => avatar.category === category);
};

// Get all categories
export const getAvatarCategories = () => {
  const categories = [...new Set(avatars.map(avatar => avatar.category))];
  return categories.map(cat => ({
    id: cat,
    name: cat.charAt(0).toUpperCase() + cat.slice(1),
    count: avatars.filter(a => a.category === cat).length
  }));
};

// Get random avatar
export const getRandomAvatar = () => {
  return avatars[Math.floor(Math.random() * avatars.length)];
};

// Get color by ID
export const getColorById = (id) => {
  return profileColors.find(color => color.id === id);
};
